// extracted by mini-css-extract-plugin
module.exports = {"button":"SocialButton_button__u_Lyp","icon":"SocialButton_icon__S4TQe"};